import api, { GetApiReturn, GetApiReturnError, ValidateAxiosError } from '@/modules/api.service';
import { Endpoints } from '@/shared/constants/endpoints';
import { ReadGastoDto, CreateGastoDto, UpdateGastoDto } from '@/api.types';

export async function GetGastos(skip: number, take: number, tipoGastoId?: number) {
  const params: any = { skip: skip, take: take };
  if (tipoGastoId) {
    params.tipoGastoId = tipoGastoId;
  }
  return api
    .get(Endpoints.GASTO, { params })
    .then((response) => {
      return GetApiReturn<ReadGastoDto>(response.data as Array<ReadGastoDto>);
    })
    .catch((error) => {
      ValidateAxiosError<ReadGastoDto>(error, 'Falha ao listar Gastos.');
      return GetApiReturnError<ReadGastoDto>();
    });
}

export async function GetGasto(id: number) {
  return api
    .get<ReadGastoDto>(Endpoints.GASTO + '/' + id)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return ValidateAxiosError<ReadGastoDto>(error, 'Falha ao buscar o Gasto.' + id);
    });
}

export async function SetGasto(gasto: CreateGastoDto | UpdateGastoDto) {
  if (gasto.id !== null && gasto.id != undefined && gasto.id > 0) {
    return api
      .put(Endpoints.GASTO + '/' + gasto.id, gasto as UpdateGastoDto)
      .then(() => {
        return 'Gasto atualizado.';
      })
      .catch((error) => {
        return ValidateAxiosError<string>(
          error,
          'Falha ao atualizar o Gasto.',
        );
      });
  } else {
    return api
      .post(Endpoints.GASTO, gasto as CreateGastoDto)
      .then(() => {
        return 'Gasto cadastrado.';
      })
      .catch((error) => {
        return ValidateAxiosError<string>(
          error,
          'Falha ao cadastrar o Gasto.',
        );
      });
  }
}

export async function DeleteGasto(id: number) {
  return api
    .delete(Endpoints.GASTO + '/' + id)
    .then(() => {
      return 'Gasto removido.';
    })
    .catch((error) => {
      return ValidateAxiosError<string>(error, 'Falha ao remover Gasto.');
    });
}